import { actions } from './actions'

const initialState = {
  proveedores: {
    data: [],
    loading: false,
    error: '',
  },
  proveedor: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function proveedoresReducer(state = initialState, action) {
  switch (action.type) {
    case actions.PROVEEDORES_LOAD_REQUESTED:
      return { ...state, proveedores: { ...state.proveedores, data: null, loading: true } }
    case actions.PROVEEDORES_LOAD_SUCCEEDED:
      return {
        ...state,
        proveedores: { ...state.proveedores, data: action.payload, loading: false, reload: false },
      }
    case actions.PROVEEDORES_LOAD_FILED:
      return {
        ...state,
        proveedores: { ...state.proveedores, loading: false, error: action.error },
      }
    case actions.PROVEEDOR_DELETE_REQUESTED:
      return {
        ...state,
        proveedores: { ...state.proveedores, loading: true, error: '' },
      }
    case actions.PROVEEDOR_DELETE_SUCCEEDED:
      return {
        ...state,
        proveedores: {
          ...state.proveedores,
          data: state.proveedores.data.filter(proveedor => proveedor.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.PROVEEDOR_DELETE_FILED:
      return {
        ...state,
        proveedores: { ...state.proveedores, loading: false, error: action.error },
      }
    case actions.PROVEEDOR_BYID_LOAD_INSERT_REQUESTED:
      return {
        ...state,
        proveedor: { ...state.proveedor, data: null, loading: false, error: '' },
      }
    case actions.PROVEEDOR_BYID_LOAD_REQUESTED:
      return {
        ...state,
        proveedor: { ...state.proveedor, loading: true, error: '' },
      }
    case actions.PROVEEDOR_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        proveedor: { ...state.proveedor, data: action.payload, loading: false, error: '' },
      }
    case actions.PROVEEDOR_BYID_LOAD_FILED:
      return {
        ...state,
        proveedor: { ...state.proveedor, data: null, loading: false, error: action.error },
      }
    case actions.PROVEEDOR_UPDATE_REQUESTED:
      return {
        ...state,
        proveedor: { ...state.proveedor, loading: true, error: '' },
      }
    case actions.PROVEEDOR_UPDATE_SUCCEEDED:
      return {
        ...state,
        proveedor: { ...state.proveedor, data: action.payload, loading: false, error: '' },
      }
    case actions.PROVEEDOR_UPDATE_FILED:
      return {
        ...state,
        proveedor: { ...state.proveedor, loading: false, error: action.error },
      }
    case actions.PROVEEDOR_INSERT_REQUESTED:
      return {
        ...state,
        proveedor: { ...state.proveedor, loading: true, error: '' },
      }
    case actions.PROVEEDOR_INSERT_SUCCEEDED:
      return {
        ...state,
        proveedor: { ...state.proveedor, data: action.payload, loading: false, error: '' },
      }
    case actions.PROVEEDOR_INSERT_FILED:
      return {
        ...state,
        proveedor: { ...state.proveedor, loading: false, error: action.error },
      }
    default:
      return state
  }
}
